export default `uniform vec3 color;

void main() {
    vec2 xy = gl_PointCoord.xy - vec2(0.5);
    float ll = length(xy);
    float outerRadius = 0.5;
    float innerRadius = 0.25;
    
    float alpha = smoothstep(innerRadius, outerRadius, ll);
    alpha *= float(ll <= outerRadius);

    gl_FragColor = vec4(color, alpha);
}`